export default __webpack_public_path__ + "static/media/hero-bcg-2.052eeae4.jpeg";